'use client';

import type { ComponentPropsWithoutRef } from 'react';
import { useMoneyFormat } from '@/components/shell/MoneyFormatContext';

type Props = {
  amount: number;
  /**
   * Legacy prop; EUR hint in brackets is disabled globally.
   * Kept for backward compatibility of existing call sites.
   */
  showEurEquivalent?: boolean;
} & Omit<ComponentPropsWithoutRef<'span'>, 'children'>;

/**
 * Отображение суммы с валютой через {@link MoneyFormatProvider} (сейчас AZN, позже — из конфига/ивента).
 * Для AZN дополнительно показывает пересчёт в евро в скобках (без отдельного поля в API).
 * Евро рендерится чуть меньше основной суммы (`0.82em`), чтобы визуально читать акцент на ₼.
 */
export function FormattedPrice({
  amount,
  showEurEquivalent: _showEurEquivalent,
  className,
  ...rest
}: Props) {
  const { format } = useMoneyFormat();

  return (
    <span className={className} suppressHydrationWarning {...rest}>
      {format(amount)}
    </span>
  );
}
